import React from 'react';
import styled, { keyframes} from 'styled-components';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const deafultColor = ({ color }) => (color || '#14c856');
const deafultSize = ({ size }) => (size || '1.5rem');
const deafultBorderWidth = ({ borderWidth }) => (borderWidth || '3px');
const deafultSpeed = ({ speed }) => (speed || '400ms');

export default styled.div`
  width: ${deafultSize};
  height: ${deafultSize};
  border-width: ${deafultBorderWidth};
  border-style: solid;
  border-top-color: ${deafultColor};
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-left-color: ${deafultColor};
  border-radius: 50%;
  animation: ${rotate} ${deafultSpeed} linear infinite;
`;